import { render, staticRenderFns } from "./AssignmentSettingToIpRadio.vue?vue&type=template&id=52f552ec&scoped=true"
import script from "./AssignmentSettingToIpRadio.vue?vue&type=script&lang=js"
export * from "./AssignmentSettingToIpRadio.vue?vue&type=script&lang=js"
import style0 from "./AssignmentSettingToIpRadio.vue?vue&type=style&index=0&id=52f552ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f552ec",
  null
  
)

export default component.exports